import React, { useContext } from "react";
import { Text, ResourceList, InlineStack, BlockStack } from "@shopify/polaris";
import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";

import { ruleItemProp } from "app/shipping/modules/operator/features/rule/propTypes";

import { baseHelper } from "lib/helpers";
import Actions from "./action";

const RuleItem = (props) => {
  const {
    moneyFormat,
    item,
    bands = [],
    destinations,
    products,
    isVendorAllowed,
    toggleModal,
    toggleDeleteModal,
  } = props;
  const {
    _id: id,
    shippingBandId,
    price,
    description,
    condition,
    destinationCode,
    productId,
    priceType,
    isShippingDisabled,
    createdAt,
    updatedAt,
  } = item;

  const { cms } = useContext(PrivateContext);
  const isDestination = condition === constant.DESTINATION;
  const isProduct = condition === constant.PRODUCT;
  const shippingBand = (bands.length > 0 && bands.find((key) => key.value === shippingBandId)) || {};

  const { options: countries = [] } =
    destinations.find(
      (destination) => destination && destination.options.find((option) => option.value === destinationCode)
    ) || {};
  const destination = countries.find((country) => country.value === destinationCode);
  const product = products.find((pItem) => pItem.value === productId);
  const isFreeOption = priceType === constant.FREE;
  const priceTypeText = isFreeOption ? cms("label.free") : cms("label.fixed");
  const shortcutActions = [
    {
      content: cms("button.edit"),
      onAction: () => toggleModal(id),
      disabled: !isVendorAllowed,
      variant: "secondary",
    },
    {
      content: cms("button.delete"),
      variant: "primary",
      tone: "critical",
      onAction: () => toggleDeleteModal(id),
      disabled: !isVendorAllowed,
    },
  ];

  return (
    <ResourceList.Item id={id} accessibilityLabel={`${cms("label.viewDetails")} ${shippingBand.label}`}>
      <BlockStack gap="400">
        <InlineStack blockAlign="start" align="space-between" wrap={false}>
          <BlockStack>
            <h3>
              <Text as="span" fontWeight="semibold">
                {shippingBand.label}
              </Text>
            </h3>
            <Text variant="bodySm" as="p">
              {description}
            </Text>
          </BlockStack>
          <Actions actions={shortcutActions} />
        </InlineStack>

        <BlockStack>
          {isDestination && (
            <Text variant="bodySm" as="p">
              {`${cms("label.destination")}: ${destination && destination.label}`}
            </Text>
          )}
          {isProduct && (
            <Text variant="bodySm" as="p">
              {`${cms("label.product")}: ${product && product.label}`}
            </Text>
          )}
          <Text variant="bodySm" as="p">{`${cms("label.priceType")}: ${priceTypeText}`}</Text>
          <Text variant="bodySm" as="p">{`${cms("label.cost")}: ${moneyFormat} ${isFreeOption ? "0" : price}`}</Text>
          <Text variant="bodySm" as="p">
            {`${cms("label.shipping")}: ${isShippingDisabled ? cms("label.disabled") : cms("label.enabled")}`}
          </Text>
          {createdAt && <Text variant="bodySm" as="p">{`Created At: ${baseHelper.formatDate(createdAt)}`}</Text>}
          {updatedAt && <Text variant="bodySm" as="p">{`Last updated At: ${baseHelper.formatDate(updatedAt)}`}</Text>}
        </BlockStack>
      </BlockStack>
    </ResourceList.Item>
  );
};

RuleItem.propTypes = ruleItemProp.type;

export default RuleItem;
